module.exports = __webpack_public_path__ + "img/MN.d267c5d0.png";